export const root = "r1n6yp3";
export const active = "anazfg3";
export const blip = "b1oakczb";
export const betaTag = "b1e5gole";
export const newTag = "n1mie8jg";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");